<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <div class="container pt-3">
            <ButtonTag
                :is-tw-main-btn="true"
                url="add-purchase-refund"
                :is-w100="false"
            >
                <div class="pt-1">
                    {{ $t('returnProducts.newReturn') }}
                </div>
            </ButtonTag>
        </div>

        <table class="w-full mt-3" v-if="hasPurchaseRefund">
            <thead class="h-11 bg-lightGray font-bold">
            <tr>
                <th class="d-none d-lg-table-cell pl-3">{{ $t('printView.receipt') }}</th>
                <th>{{ $t('returnProducts.returnDate') }}</th>
                <th>{{ $t('supplier.title') }}</th>
                <th class="d-none d-md-table-cell">{{ $t('returnProducts.returnAmount') }}</th>
                <th class="d-none d-md-table-cell">{{ $t('price') }}</th>
                <th>{{ $t('detailed') }}</th>
            </tr>
            </thead>
            <tbody
                v-for="item in getProductRefunds"
                :key="item.id"
            >
            <tr class="h-11 cursor-pointer">
                <td class="d-none d-lg-table-cell pl-3">{{ item.purchase.id }}</td>
                <td>{{ dateTimeFormat(item.createdAt, false, true)}}</td>
                <td class="font-bold text-main">{{getSupplierName(item)}}</td>
                <td class="d-none d-md-table-cell">
                    {{item.refundAmount}} {{ $t('returnProducts.type') }}
                </td>
                <td class="d-none d-md-table-cell">
                    {{showCurrencyById(item.refundCurrency.id, item.refundPrice)}}
                </td>
                <td @click="showOnePurchaseRefund(item)">
                    <img src="/images/read-more.png" alt="" class="h-7">
                </td>
            </tr>
            </tbody>
        </table>

        <RowColumn v-if="hasPurchaseRefund" class="mt-3 container">
            <Pagination
                :search="search"
                base-url="purchase-refund"
                :total-items="getProductRefundTotalCount"
                method-name="fetchProductRefunds"/>
        </RowColumn>
    </Row>
</template>

<script>
import currencyFormat from "../../mixin/currencyFormatMixin";
import Row from "../../components/html/Row";
import RowColumn from "../../components/RowColumn";
import {mapActions, mapGetters} from "vuex";
import accessMixin from "@/mixin/accessMixin";
import ButtonTag from "@/components/html/ButtonTag";
import dateFormatting from "@/mixin/dateFormattingMixin";
import Pagination from "@/components/html/Pagination";

export default {
    name: "PurchaseRefundList",
    components: {
        Pagination,
        ButtonTag,
        RowColumn,
        Row,
    },
    mixins: [currencyFormat, accessMixin, dateFormatting],
    data() {
        return {
            search: {
                page: 1,
            },
            hasPurchaseRefund: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'returnProducts.return'},
            ],
        }
    },
    computed: mapGetters(["getProductRefunds", 'getProductRefundTotalCount']),
    methods: {
        ...mapActions(['fetchProductRefunds', 'setBreadcrumbItems']),
        getSupplierName(item) {
            return item.supplier.isCompany ?
                item.supplier.supplierCompany.name :
                item.supplier.person.givenName + ' ' + item.supplier.person.familyName
        },
        showOnePurchaseRefund(purchaseRefund) {
            this.$i18nHelper.toUrl('purchase-refund/' + purchaseRefund.purchase.id)
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true
        this.fetchProductRefunds(this.search)
        this.hasPurchaseRefund = true

        this.$root.showOverlay = false
    },
}
</script>

<style scoped>
table tbody tr {
    border-bottom: 1px solid #eaeaea;
}
</style>